import styled from "styled-components";

export const CardsContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  justify-content: center;
  .float-cards-container {
    transform: translate(0%, 30%);
    bottom: 0;
    top: 50%;
    left: 50%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    height: 100%;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: center;
  }

  @media (max-width: 1020px) {
    .float-cards-container {
      grid-template-columns: repeat(1, 1fr);
      position: static;
      transform: translate(0%);
      margin: 40px auto;
      width: 80%;
      justify-items: center;
    }
  }
`;
